import { BREAK_POINTS } from "@dmm-com/rocket-web-ui-library";
import { DEFAULT_TITLE, PAGE_DESCRIPTION_SUFFIX, PAGE_TITLE_SUFFIX } from "~/const/meta";

// VODトップで表示するカルーセル1つあたりのアイテム数
export const SP_BREAK_SIZE = 375;
export const MIN_SQUARE_ITEM_NUM = 1.5; // 1:1フリー画像の最小個数
export const MIN_RANKING_ITEM_NUM = 2.5; // ランキングの最小個数
export const MIN_LANDSCAPE_ITEM_NUM = 2; // 16:9画像の最小個数
export const SP_VERICAL_ITEM_NUM = 3; // 指定がない画像の最小個数

/*
 * グラビアは147x200までの画像しか持っておらず大きく表示すると画像がぼやけてしまう様です。
 * よってRANKING_GRAVUREは他の棚と同等のサイズに変更
 * https://github.com/dmm-com/rocket-web-pbi/issues/4620
 */

export const SIZES = {
  RANKING: {
    SP: 148,
    TABLET: 170,
    PC: 170,
    MONITOR: 210,
    IS_RANKING: true,
    IS_SQUARE: false,
    IS_LANDSCAPE: false,
  },
  RANKING_GRAVURE: {
    SP: 114,
    TABLET: 155,
    PC: 155,
    MONITOR: 155,
    IS_RANKING: false, // 他の棚(LARGE)と同じくSPの場合にカルーセル数3つ固定にする為
    IS_SQUARE: false,
    IS_LANDSCAPE: false,
  },
  CONTINUE: {
    SP: 140,
    TABLET: 228,
    PC: 230,
    MONITOR: 230,
    IS_RANKING: false,
    IS_SQUARE: false,
    IS_LANDSCAPE: true,
  },
  BOOKMARK: {
    SP: 114,
    TABLET: 140,
    PC: 140,
    MONITOR: 180,
    IS_RANKING: false,
    IS_SQUARE: false,
    IS_LANDSCAPE: false,
  },
  RECOMMEND: {
    SP: 114,
    TABLET: 140,
    PC: 140,
    MONITOR: 180,
    IS_RANKING: false,
    IS_SQUARE: false,
    IS_LANDSCAPE: false,
  },
  RECOMMEND_GRAVURE: {
    SP: 114,
    TABLET: 155,
    PC: 155,
    MONITOR: 155,
    IS_RANKING: false,
    IS_SQUARE: false,
    IS_LANDSCAPE: false,
  },
  RESERVATION: {
    SP: 140,
    TABLET: 228,
    PC: 230,
    MONITOR: 230,
    IS_RANKING: false,
    IS_SQUARE: false,
    IS_LANDSCAPE: true,
  },
  LARGE: {
    SP: 114,
    TABLET: 140,
    PC: 140,
    MONITOR: 180,
    IS_RANKING: false,
    IS_SQUARE: false,
    IS_LANDSCAPE: false,
  },
  MEDIUM: {
    SP: 114,
    TABLET: 140,
    PC: 140,
    MONITOR: 180,
    IS_RANKING: false,
    IS_SQUARE: false,
    IS_LANDSCAPE: false,
  },
  RECTANGLE: {
    SP: 167,
    TABLET: 310,
    PC: 332,
    MONITOR: 332,
    IS_RANKING: false,
    IS_SQUARE: false,
    IS_LANDSCAPE: false,
  },
  SQUARE: {
    SP: 280,
    TABLET: 280,
    PC: 280,
    MONITOR: 280,
    IS_RANKING: false,
    IS_SQUARE: true,
    IS_LANDSCAPE: false,
  },
} as const;

export const CAROUSEL_BREAK_POINTS = {
  // MEMO : BREAK_POINTS.sp は 599, BREAK_POINTS.pc は 1025 のため BREAK_POINTS から参照していない
  SP: 375,
  TABLET: BREAK_POINTS.tablet, // Tableのみ600px
  PC: 1024,
  MONITOR: BREAK_POINTS.monitor,
} as const;

export const HEAD_PROPERTY_TEMPLATE = {
  VOD_TOP: {
    TITLE: DEFAULT_TITLE,
    DESCRIPTION: PAGE_DESCRIPTION_SUFFIX,
  },
  CATEGORY_TOP: {
    TITLE: `作品一覧${PAGE_TITLE_SUFFIX}`,
    DESCRIPTION: `作品一覧です。${PAGE_DESCRIPTION_SUFFIX}`,
  },
} as const;

export const INFINITY_SCROLL_CONFIG = {
  FIRST_LIST_NUM: 8,
  LIST_NUM: 10,
  NEXT_FETCH_LINE: 300,
};
